import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmp8isf8rfx/layouts/custom.vue").then(m => m.default || m))
}